import HotelsSearchControlsGC, {
  fetchSuggestions,
} from '@skyscanner-internal/global-components/hotels-search-controls';
import logger from 'saddlebag-logger';

import getDayviewUrl from './utils/url';

import type { OnSearchPayload } from '@skyscanner-internal/global-components/hotels-search-controls/common/types/search';
import type { HotelsSearchControlsGCWrapperProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/hotels-components/HotelsSearchControlsGCWrapperProps';
import type { MappingShape } from '@skyscanner-internal/landing-pages-shared-types/types-shared/hotels-components/types';

const redirectOnSubmit = ({
  adults,
  checkInDate,
  checkOutDate,
  childrenAges,
  copyPastePartnerId,
  destination,
  filter,
  rooms,
  source,
}: OnSearchPayload) => {
  window.location.assign(
    getDayviewUrl({
      destination,
      checkInDate,
      checkOutDate,
      adults,
      rooms,
      childrenAges,
      filter,
      copyPastePartnerId,
      source,
    }),
  );
};

const createRedirectWithFilter =
  (presetFilter: MappingShape | undefined) => (params: OnSearchPayload) => {
    const mergedFilter = {
      ...presetFilter,
      ...params.filter,
    };

    redirectOnSubmit({
      ...params,
      filter: mergedFilter,
    });
  };

const HotelsSearchControlsGCWrapper = ({
  autosuggestExpVal,
  cldr,
  defaultOpenCalendar,
  device,
  enableCopyPasteHotelsHomepage,
  enableDoubleCalendar,
  enablePoiSuggestionsOnMobile,
  enableShowExpandedInputValue,
  filters,
  hideCopyPasteImageTab,
  isProductionEnv,
  isWebView,
  searchParams,
  showOnlyCopyPasteTabs,
  strings,
  trackingProps,
}: HotelsSearchControlsGCWrapperProps) => (
  <HotelsSearchControlsGC
    cldr={cldr}
    device={device}
    featureDecisions={{
      autosuggestExpVal,
      enableCopyPasteHotelsHomepage,
      enableDoubleCalendar,
      enablePoiSuggestionsOnMobile,
      enableShowExpandedInputValue,
      showOnlyCopyPasteTabs,
      hideCopyPasteImageTab,
      defaultOpenCalendar,
    }}
    isProductionEnv={isProductionEnv}
    isWebView={isWebView}
    logger={logger}
    onSearch={createRedirectWithFilter(filters)}
    onSuggestionRequest={fetchSuggestions}
    searchParams={searchParams}
    showPreference
    strings={strings}
    trackingProps={trackingProps}
    enableRecentSearch
  />
);

export default HotelsSearchControlsGCWrapper;
